exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/vue-slider-component/theme/default.css"), "");

// module
exports.push([module.id, ".no-wrap[data-v-3c468dd8]{white-space:nowrap}.offer-component[data-v-3c468dd8]{background-color:#4baf4d!important}.offer-component[data-v-3c468dd8]:hover{background-color:green!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3c468dd8&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/grid/OfferComponent.vue
// module id = 877
// module chunks = 2